// Track JS execution start
import { ModalProvider } from './features/modal-manager/index.ts'
import { scan } from 'react-scan' // must be imported before React and React DOM
import ReactDOM from 'react-dom/client'
import Router from './router'
import './styles/index.css'
import { ReactQueryProvider } from './lib/react-query/index.ts'

performance.mark('[Rundown] JS execution start')
console.debug('[Performance] JS execution start')

scan({
  enabled: import.meta.env.VITE_SCAN === 'true',
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <ReactQueryProvider>
    <ModalProvider>
      <Router />
    </ModalProvider>
  </ReactQueryProvider>,
)
